import InputField from "../../../components/InputField";
import OptionalFields from "../../../components/OptionalFields";
import Toggle from "../../../components/Toggle";

export default function ImprumutatStep({ data, errors, update }) {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
      <div style={{ width: "100%" }}>
        <Toggle
          label="Persoana juridica"
          description="Imprumutatul este o firma / societate comerciala"
          checked={!!data.imprumutatPJ}
          onChange={() => update("imprumutatPJ")(!data.imprumutatPJ)}
        />
      </div>

      {data.imprumutatPJ ? (
        <>
          <InputField label="Denumire societate" value={data.imprumutatFirma} onChange={update("imprumutatFirma")} placeholder="ex: SC Exemplu SRL" required error={errors.imprumutatFirma} />
          <InputField label="CUI" value={data.imprumutatCUI} onChange={update("imprumutatCUI")} placeholder="ex: RO12345678" required half error={errors.imprumutatCUI} />
          <InputField label="Nr. Reg. Comertului" value={data.imprumutatRegCom} onChange={update("imprumutatRegCom")} placeholder="ex: J40/1234/2020" half error={errors.imprumutatRegCom} />
          <InputField label="Sediu social" value={data.imprumutatSediu} onChange={update("imprumutatSediu")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.imprumutatSediu} />
          <InputField label="Reprezentant legal" value={data.imprumutatReprezentant} onChange={update("imprumutatReprezentant")} placeholder="ex: Ionescu Maria" required error={errors.imprumutatReprezentant} />
        </>
      ) : (
        <>
          <InputField label="Nume complet" value={data.imprumutatNume} onChange={update("imprumutatNume")} placeholder="ex: Ionescu Maria" required error={errors.imprumutatNume} />
          <InputField label="Adresa de domiciliu" value={data.imprumutatAdresa} onChange={update("imprumutatAdresa")} placeholder="ex: Str. Alta nr. 5, Cluj-Napoca" required error={errors.imprumutatAdresa} />
          <OptionalFields>
            <InputField label="CNP" value={data.imprumutatCNP} onChange={update("imprumutatCNP")} placeholder="ex: 2234567890123" half error={errors.imprumutatCNP} helperText="Opțional — poți completa de mână pe document" />
            <InputField label="Serie si nr. CI" value={data.imprumutatCI} onChange={update("imprumutatCI")} placeholder="ex: MZ 654321" half error={errors.imprumutatCI} helperText="Opțional — poți completa de mână pe document" />
          </OptionalFields>
        </>
      )}
    </div>
  );
}
